import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Brand } from 'src/models/brand';
import { NavbarMenu } from 'src/models/navbarMenu';
import { SideNavToggle } from '../../../models/sidenavToggle';
import { filter } from 'rxjs/operators';
import { HelperService } from 'src/services/helperService';
import { TranslateService } from '@ngx-translate/core';
import { User } from 'src/models/user';
import { AppComponent } from 'src/app/app.component';

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.sass'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class SidenavComponent implements OnInit {

  @Output() onToggleSidenav: EventEmitter<SideNavToggle> = new EventEmitter();

  @Input() navbarMenus?: NavbarMenu[];
  @Input() brand?: Brand;

  screenWidth: number = 0;
  isExpanded: boolean = false;
  activeURL: string = '';
  userProfile!: User;

  constructor(
    private router: Router,
    public helperService: HelperService,
    private translate: TranslateService,public appComponent:AppComponent
    ) 
  {
  
    
      translate.setDefaultLang('en-US');
      this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((nav) => {
      if(nav instanceof NavigationEnd)
        this.activeURL = nav.url.substring(1);
    });

  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenWidth = window.innerWidth;
    // console.log(this.navbarMenus);
    if (this.screenWidth <= 768) {
      this.isExpanded = false;
      this.onToggleSidenav.emit({ isExpanded: this.isExpanded, screenWidth: this.screenWidth });
    }
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.onToggleSidenav.emit({ isExpanded: this.isExpanded, screenWidth: this.screenWidth });
    
  }

  toggleCollapse(): void {
    this.isExpanded = !this.isExpanded;
    this.onToggleSidenav.emit({ isExpanded: this.isExpanded, screenWidth: this.screenWidth });
    window.setTimeout(function () {    
      window.dispatchEvent(new Event('resize'));
    }, 250);
  }

  isMenuExapanded(menus: NavbarMenu[]): boolean {
    return menus.map(m => m.routeLink).includes(this.activeURL);
  }
  onCheckboxChange(value: number): void {
    this.helperService.checkbokMix = value;
    this.appComponent.showBusyIndicator = true
    this.helperService.ChangeUserMix()
  }

  onClickCloseSession(): void {    
    document.cookie.split(";").forEach(function (c) {
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    this.router.navigate(['scheduling']);
    window.location.reload();
  }

  SubMenu(TitlePageFrist:any,TitlePageSecondary:any,icon:any){
  
    this.helperService.TitlePage = TitlePageFrist+ " - "+TitlePageSecondary
    this.helperService.icon = icon
  }
  
  menuP(TitlePageFrist:any,icon:any){
    this.helperService.TitlePage = TitlePageFrist
    this.helperService.icon = icon
  }

}
